
    import CompletedSection from '../../components/Project/CompletedSection.vue';
    import ProjectsSection from '../../components/MainComponent/ProjectsSection.vue';
    import HeadingSection from '../../components/MainComponent/HeadingSection.vue';

    export default {
        head: function () {
            return {
                title: this.$store.state.projectsPageData.meta_title || this.$nuxt.$options.head.title,
                meta: [
                    { hid: 'description', name: 'description', content: this.$store.state.projectsPageData.meta_desc || this.$nuxt.$options.head.meta.find(meta => meta.name === 'description').content },

                    { hid: 'og:title', property: 'og:title', content: this.$store.state.projectsPageData.meta_title || this.$nuxt.$options.head.title },
                    { hid: 'og:description', property: 'og:description', content: this.$store.state.projectsPageData.meta_desc || this.$nuxt.$options.head.meta.find(meta => meta.name === 'description').content },
                    { hid: 'og:image', property: 'og:image', content: this.$store.state.projectsPageData.background_image },

                    { hid: 'twitter:title', name: 'twitter:title', content: this.$store.state.projectsPageData.meta_title || this.$nuxt.$options.head.title },
                    { hid: 'twitter:description', name: 'twitter:description', content: this.$store.state.projectsPageData.meta_desc || this.$nuxt.$options.head.meta.find(meta => meta.name === 'description').content },
                    { hid: 'twitter:image', name: 'twitter:image', content: this.$store.state.projectsPageData.background_image }
                ],
            };
        },
        components: {
            HeadingSection,
            ProjectsSection,
            CompletedSection,
        },
        computed: {
            projectsPageData() {
                return this.$store.state.projectsPageData;
            },
        },
        async asyncData(context) {
            await context.app.$getDataFromCache(`/wp-json/wp/v2/pages/13`)
                .then((response) => {
                    context.store.dispatch("setProjectsPageData", response.data.acf);
                });
            await context.store.dispatch("setPageChangeAnimationValueFalse");
        },
    };
